import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
export var FrameGraphHandle = function FrameGraphHandle() {
  _classCallCheck(this, FrameGraphHandle);

  this.index = void 0;
};
//# sourceMappingURL=FrameGraphHandle.js.map